export default function LiveMusicModal({ show, onClose, artistName, artistTime }) {
  if (!show) return null;

  return (
    <div className="blurred-app-state">
      <div className="modal-card">
        <button className="sidebar-close-btn" onClick={onClose}>&times;</button>
        <h2>Live Music Alert!</h2>
        <p className="promo-text">Stick around after your game for the next show:</p>
        <div className="promo-venue-card">
          <h3>{artistName}</h3>
          <p className="promo-subtext" style={{ marginBottom: 10 }}>{artistTime}</p>
          <a href="https://byrnespub.com/shows/" target="_blank" rel="noreferrer" className="promo-link">View Full Schedule</a>
        </div>
        <button className="btn-bank" style={{ marginTop: 20 }} onClick={onClose}>Rock On!</button>
      </div>
    </div>
  );
}
